import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import stylesheet, { directions } from 'src/constants/stylesheet';
import Part, { PartProps } from './Part';

export type MainPartProps = PartProps & {
    topLine: boolean;
};

const styles = {

    content: {
        ...stylesheet.PaddingGutter(1, directions.sides),
        ...stylesheet.PaddingGutter(2, directions.top)
    },
    topLine: {
        '&:after': {
            content: '""',
            position: 'absolute',
            backgroundColor: 'black',
            height: 1,
            zIndex: 999,
            top: 0,
            ...stylesheet.MarginGutter(1, directions.sides),
            left: 0,
            right: 0
        }
    }
};

type Props =
    MainPartProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

const MainPart: React.FunctionComponent<Props> = (props) => {
    const { classes, contentProps, children, topLine, ...rest } = props;

    return (
        <Part
            {...rest}
            contentProps={{ 
                ...contentProps, 
                className: classNames(
                    contentProps && contentProps.className, 
                    classes!.content,
                    topLine && classes!.topLine) 
            }}
        >
            {children}
        </Part>
    );
}

export default withStyles(styles)(withAppScroller(MainPart));


// WEBPACK FOOTER //
// ./src/components/MainPart.tsx